module.exports = __webpack_public_path__ + "img/login-elitesport.b5a6a256.svg";